export default __webpack_public_path__ + "static/bathroom-retro-style-a221bf62300724ab4d780dad6c603aeb.jpg";